import React, { useEffect, useState } from "react";
import { Card, CardBody, Center, Skeleton } from "@chakra-ui/react";
import CanvasJSReact from '@canvasjs/react-charts';
import { useFetchCustomQueryCoursewise } from "../../api/fetchData";

const FunnelReport = ({ module, query, reportsMatrix }) => {
    // eslint-disable-next-line
    const CanvasJS = CanvasJSReact.CanvasJS;
    const CanvasJSChart = CanvasJSReact.CanvasJSChart;

    const [chartData, setChartData] = useState([
        { y: 0, label: "Follow Up" },
        { y: 0, label: "RFS" },
        { y: 0, label: "RPP" },
        { y: 0, label: "RPC" },
        { y: 0, label: "Enrolled" }
    ]);

    const { data } = useFetchCustomQueryCoursewise(module, query, true);

    const options = {
        animationEnabled: true,
        data: [{
            type: "funnel",
            toolTipContent: `<div><p style="text-align:center;"><b>{label}</b></p><br /><p style="text-align:center;"><b>{y} - ({percentage}%)</b></p></div>`,
            indexLabelPlacement: "inside",
            indexLabel: "{label}: {y} - ({percentage}%)",
            indexLabelFontWeight: "bold",
            indexLabelTextAlign: "center",
            dataPoints: chartData
        }]
    };

    const chartContainerProps = {
        height: '425px',
        width: '100%'
    };

    let dataPoints;
    let total;
    //calculate percentage
    dataPoints = options.data[0].dataPoints;
    total = dataPoints.reduce((previous, current) => (previous + Number(current.y)), 0);
    for ( let i = 0; i < dataPoints.length; i++ ) {
        options.data[0].dataPoints[i].percentage = ((dataPoints[i].y / total) * 100).toFixed(2);
    }

    useEffect(() => {
        if ( reportsMatrix.find(({ query }) => query === 'Enrolled') === undefined ) {
            reportsMatrix.push({
                title: ' -- Enrolled',
                module: 'Potentials',
                course_cc: 'Commercial Cookery [Certificate IV] - (Full time - 1.5 years)',
                course_hm: 'Hospitality Management [Advanced Diploma] - (Full time - 2 years)',
                course_pc: 'Patisserie [Certificate IV] - (Full time - 1.5 years)',
                course_em: 'Event Management [Diploma] - (Part time - 2 years)',
                course_tt: 'Travel and Tourism Management [Advanced Diploma] - (Full time - 1.5 years)',
                query: 'Enrolled'
            });
        }
        const chartDataArray = reportsMatrix.map(report => ({
            label: report.title.replace(' -- ', '') === 'Following Up' ? report.title.replace(' -- ', '') : report.title.replace(' -- ', '').split(" ")[report.title.replace(' -- ', '').split(" ").length - 1].replace('(', '').replace(')', ''),
            y: (!Object.hasOwn(data[report.module], report.course_pc) ? 0 : Object.hasOwn(data[report.module][report.course_pc], report.query) ? data[report.module][report.course_pc][report.query] : 0) +
            (!Object.hasOwn(data[report.module], report.course_hm) ? 0 : Object.hasOwn(data[report.module][report.course_hm], report.query) ? data[report.module][report.course_hm][report.query] : 0) +
            (!Object.hasOwn(data[report.module], report.course_cc) ? 0 : Object.hasOwn(data[report.module][report.course_cc], report.query) ? data[report.module][report.course_cc][report.query] : 0) +
            (!Object.hasOwn(data[report.module], report.course_tt) ? 0 : Object.hasOwn(data[report.module][report.course_tt], report.query) ? data[report.module][report.course_tt][report.query] : 0) +
            (!Object.hasOwn(data[report.module], report.course_em) ? 0 : Object.hasOwn(data[report.module][report.course_em], report.query) ? data[report.module][report.course_em][report.query] : 0) 
        }));
        setChartData(chartDataArray.sort(({y:previous}, {y:current}) => current - previous));
    }, [data, reportsMatrix]);

    return (
        <Card
            direction={{ base: 'column', sm: 'row' }}
            overflow='hidden'
            variant='outline'
            align='center'
            borderRadius={10}
            marginX={{ base: '5px', sm: '0px', md: '5px', lg: '5px' }}
        >
            <CardBody width={'100%'}>
                <Center width={'100%'}>
                    <Skeleton fadeDuration={10} height={chartContainerProps.height} width={chartContainerProps.width} isLoaded={data}>
                        <CanvasJSChart options = {options} containerProps={chartContainerProps} />
                    </Skeleton>
                </Center>
            </CardBody>
        </Card>
    );
};

export default FunnelReport;